import { makeStyles, Typography, TypographyProps } from "@material-ui/core";
import { forwardRef, ReactNode } from "react";

export interface LyfeTypographyTypes {
	type?:
		| "bold"
		| "regular"
		| "semi-bold"
		| "h1"
		| "h2"
		| "h3"
		| "h4"
		| "h5"
		| "h6"
		| "h7"
		| "cta"
		| "mainText"
		| "fieldText"
		| "tableHeading"
		| "tableMainText"
		| "labels"
		| "status"
		| "detailsHeader"
		| "graphTitles"
		| "inherit";
}

export default forwardRef<HTMLSpanElement, TypographyProps & LyfeTypographyTypes>(function LyfeTypography(props, ref) {
	const { children, type, ...other } = props;
	const classes = useStyles();

	function renderClass() {
		switch (type) {
			case "bold":
				return classes.bold;
			case "semi-bold":
				return classes.semiBold;
			case "h1":
				return classes.h1;
			case "h2":
				return classes.h2;
			case "h3":
				return classes.h3;
			case "h4":
				return classes.h4;
			case "h5":
				return classes.h5;
			case "h6":
				return classes.h6;
			case "h7":
				return classes.h7;
			case "cta":
				return classes.cta;
			case "mainText":
				return classes.mainText;
			case "fieldText":
				return classes.fieldText;
			case "tableHeading":
				return classes.tableHeading;
			case "tableMainText":
				return classes.tableMainText;
			case "labels":
				return classes.labels;
			case "status":
				return classes.status;
			case "detailsHeader":
				return classes.detailsHeader;
			case "graphTitles":
				return classes.graphTitles;
			case "inherit":
				return classes.inherit;
			default:
				return classes.regular;
		}
	}

	return (
		<Typography ref={ref} {...other} className={`${renderClass()} ${other.className}`}>
			{children}
		</Typography>
	);
});

const useStyles = makeStyles({
	regular: {},
	bold: {
		fontWeight: 600,
	},
	semiBold: {
		fontWeight: 600,
	},
	h1: {
		fontSize: "2rem",
	},
	h2: {
		fontSize: "1.5rem",
		fontWeight: 600,
	},
	h3: {
		fontSize: "1.375rem",
		fontWeight: 600,
	},
	h4: {
		fontSize: "1.25rem",
	},
	h5: {
		fontSize: "1.125rem",
		textTransform: "uppercase",
	},
	h6: {
		fontSize: "1rem",
		fontWeight: 300,
		textTransform: "uppercase",
	},
	h7: {
		fontSize: "0.875rem",
		fontWeight: 600,
		textTransform: "uppercase",
	},
	cta: {
		fontSize: "0.75rem",
	},
	mainText: {
		fontSize: "1.125rem",
	},
	fieldText: {
		fontSize: "1rem",
	},
	tableHeading: {
		fontSize: "1rem",
		fontWeight: 600,
	},
	tableMainText: {
		fontSize: "0.875rem",
	},
	labels: {
		fontSize: "0.75rem",
	},
	status: {
		fontSize: "14px",
		fontWeight: 600,
		overflow: "hidden",
	},
	detailsHeader: {
		fontSize: "24px",
		fontWeight: 600,
		lineHeight: 1,
	},
	graphTitles: {
		fontSize: "0.625rem",
		fontWeight: 300,
	},
	inherit: {
		fontWeight: "inherit",
		fontSize: "inherit",
	},
});
